import { render, staticRenderFns } from "./productsList.vue?vue&type=template&id=59b30ecb&lang=pug"
import script from "./productsList.vue?vue&type=script&lang=js"
export * from "./productsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports